import { useIsSignedIn, Login } from "@microsoft/mgt-react";
import { useTranslation } from "react-i18next";

export default function SignInWrapper({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation();
  const [isSignedIn] = useIsSignedIn();
  if (!isSignedIn) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center text-gray-900">
        <div className="rounded-lg bg-white p-8 shadow-lg">
          <h1 className="text-2xl font-semibold">{t("auth.appTitle")}</h1>
          <p className="my-4 text-gray-600">{t("auth.signInPrompt")}</p>
          <Login loginView={"avatar"} />
        </div>
      </div>
    );
  }
  return <div className="h-full">{children}</div>;
}